var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "450px" } }, [
    _c("img", {
      attrs: {
        src: require("@/assets/images/nylogo.png"),
        alt: "",
        srcset: "",
        height: "32"
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "login-input" }, [
      _c(
        "svg",
        { staticClass: "icon login-input-i", attrs: { "aria-hidden": "true" } },
        [_c("use", { attrs: { "xlink:href": "#gold-icon-yonghuming" } })]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.username,
            expression: "username"
          }
        ],
        attrs: { placeholder: "请输入用户名", maxlength: "20" },
        domProps: { value: _vm.username },
        on: {
          blur: function($event) {
            return _vm.checkInput("username")
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.username = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.usernameErr && !_vm.username,
              expression: "usernameErr && !username"
            }
          ],
          staticClass: "login-err"
        },
        [_vm._v("用户名不能为空")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "login-input-length" }, [
        _vm._v(_vm._s(_vm.username.length) + "/20")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-input" }, [
      _c(
        "svg",
        { staticClass: "icon login-input-i", attrs: { "aria-hidden": "true" } },
        [_c("use", { attrs: { "xlink:href": "#gold-icon-mima" } })]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.password,
            expression: "password"
          }
        ],
        attrs: { placeholder: "请输入密码", type: "password", maxlength: "16" },
        domProps: { value: _vm.password },
        on: {
          blur: function($event) {
            return _vm.checkInput("password")
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.password = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.passwordErr && _vm.password.length < 8,
              expression: "passwordErr && password.length < 8"
            }
          ],
          staticClass: "login-err"
        },
        [
          _vm._v(
            _vm._s(
              _vm.password.length == 0 ? "密码不能为空" : "请输入有效的密码"
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "login-input-length" }, [
        _vm._v(_vm._s(_vm.password.length) + "/16")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-input flexStart" }, [
      _c(
        "svg",
        { staticClass: "icon login-input-i", attrs: { "aria-hidden": "true" } },
        [_c("use", { attrs: { "xlink:href": "#gold-icon-yanzhengma" } })]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.captcha,
            expression: "captcha"
          }
        ],
        staticStyle: { flex: "1", "margin-right": "30px" },
        attrs: { placeholder: "请输入验证码", maxlength: "4" },
        domProps: { value: _vm.captcha },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.login($event)
          },
          blur: function($event) {
            return _vm.checkInput("captcha")
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.captcha = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          staticStyle: { width: "120px" },
          attrs: { src: _vm.imgUrl },
          on: {
            click: function($event) {
              return _vm.varyCode()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.captchaErr && _vm.captcha.length != 4,
              expression: "captchaErr && captcha.length != 4"
            }
          ],
          staticClass: "login-err",
          staticStyle: { bottom: "-27px" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.captcha.length == 0 ? "验证码不能为空" : "请输入有效的验证码"
            )
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "login-input-length", staticStyle: { right: "156px" } },
        [_vm._v(_vm._s(_vm.captcha.length) + "/4")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "login-btn-box" },
      [
        _c(
          "a-button",
          {
            staticClass: "login-btn",
            attrs: {
              loading: _vm.loadLogin,
              type: "primary",
              disabled: !_vm.checkInput()
            },
            on: { click: _vm.login }
          },
          [_vm._v("登录")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "login-register" }, [
          _c(
            "span",
            { staticClass: "login-forget", on: { click: _vm.toForget } },
            [_vm._v("忘记密码 ")]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { margin: "0 8px" } }, [_vm._v("·")]),
          _vm._v(" "),
          _c("span", { on: { click: _vm.toRegister } }, [_vm._v(" 立即注册")])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bfc02d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bfc02d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/login-form.vue
// module id = rKHM
// module chunks = 1